import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';

import Choice from './Choice';
import { ukCupSizesData, usCupSizesData } from '../../data/sizes';
import { sizeQuizMessages as messages } from '../../data/messages';

import { updateSizeSelection } from '../../utils/helpers';

const CupSizes = ({
  country = window.location.href.indexOf("/us/") > -1 ? "en-GB" : "en-US",
  cupSizes,
  intl: { formatMessage },
  setCupSize,
  setCupSizes,
  setTempCupCache,
}) => {
  useEffect(() => {
    switch (country) {
      case 'en-US':
        setCupSizes(usCupSizesData);
        break;
      case 'en-GB':
        setCupSizes(ukCupSizesData);
        break;
      default:
        break;
    }
  }, [country]);

  return (
    <div className="sizes sizes__cup">
      <p>{formatMessage(messages.chooseCupSize)}</p>

      <div>
        {cupSizes?.map((cupSize, idx) => (
          <Choice
            key={idx}
            size={cupSize.size}
            toggleFunction={() => {
              setCupSizes(updateSizeSelection(cupSizes, cupSize.size));
              setCupSize(cupSize.size);
              setTempCupCache(cupSize.size);
            }}
            isChecked={cupSize.selected}
          />
        ))}
      </div>
    </div>
  );
};

CupSizes.propTypes = {
  country: PropTypes.string,
  cupSizes: PropTypes.array,
  intl: intlShape,
  setCupSize: PropTypes.func,
  setCupSizes: PropTypes.func,
  setTempCupCache: PropTypes.func,
};

export default injectIntl(CupSizes);
